import Searchbar, { Props } from './Searchbar';

export default Searchbar;
export { Props as SearchbarProps };
